<template>
  <div :style="{opacity: opacity}" class="u-wrapper-panel u-row u-middle">
    <div class="infos-media__title u-w3of12 u-marg-l-1of12 u-right">
      {{ title }}
    </div>
  </div>
</template>

<script>
import Opacity2D from './Opacity2D'

export default {
  mixins: [Opacity2D],

  props: {
    title: {
      type: String,
      default: ''
    },
    baseProgress: {
      type: Number,
      default: Infinity
    },
    progress: {
      type: Number,
      default: 0
    }
  },

  methods: {
    onUpdate () {
      this.computeOpacity()
    }
  }
}

</script>

<style lang="stylus">

@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/viewport-sizer'

.infos-media__title
  viewportSizer('font-size', 40, 1920)
</style>